import React, { useState } from "react";
import {
  Box,
  Grid,
  Text,
  FormControl,
  Input,
  Checkbox,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
  useToast
} from "@chakra-ui/react";

const AccountStatus = ({ statuses, handleStatusInputChange, handleStatusCheckboxChange }) => {
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [isChecked, setIsChecked] = useState(null);
  const cancelRef = React.useRef();
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleCheckboxChange = (statusId, e) => {
    setSelectedStatusId(statusId);
    setIsChecked(e.target.checked);
    onOpen();
  };

  const confirmChange = async () => {
    try {
      await handleStatusCheckboxChange(selectedStatusId, {
        target: { name: "is_full", checked: isChecked }
      });
    } catch (error) {
    }
    setSelectedStatusId(null);
    setIsChecked(null);
    onClose();
  };

  return (
    <>
      <Box p={4} borderRight="1px" borderColor="gray.200">
        <Text fontSize="lg" fontWeight="bold" mb={4}>
          وضعیت‌ها
        </Text>

        <Grid templateColumns="1fr 1fr" gap={4}>
        <Box>
            {statuses
              .filter((status) => status.platform === 2)
              .map((status) => (
                <Box key={status.id} mb={4} ml={1}>
                  <Text mb={0} color="red.700" textAlign="left">
                    {status.name}
                  </Text>
                  <Box position="relative">
                    <FormControl>
                      <Input
                        textAlign="left"
                        name="worder_id"
                        value={status.worder_id || ""}
                        onChange={(e) => handleStatusInputChange(status.id, e)}
                        padding="1rem"
                        border="1px solid"
                        borderColor="gray.300"
                        boxShadow="md"
                        _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
                      />
                      <FormControl
                        position="absolute"
                        top="50%"
                        right="10px"
                        transform="translateY(-50%)"
                        width="auto"
                      >
                        <Checkbox
                          name="is_full"
                          isChecked={status.is_full === 1}
                          onChange={(e) => handleCheckboxChange(status.id, e)} // Open confirmation dialog
                          colorScheme="red"
                        />
                      </FormControl>
                    </FormControl>
                  </Box>
                </Box>
              ))}
          </Box>
          <Box>
            {statuses
              .filter((status) => status.platform === 1)
              .map((status) => (
                <Box key={status.id} mb={4} ml={1}>
                  <Text mb={0} color="green.700" textAlign="left">
                    {status.name}
                  </Text>
                  <Box position="relative">
                    <FormControl>
                      <Input
                        name="worder_id"
                        value={status.worder_id || ""}
                        onChange={(e) => handleStatusInputChange(status.id, e)}
                        padding="1rem"
                        border="1px solid"
                        borderColor="gray.300"
                        boxShadow="md"
                        textAlign="left"
                        _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px blue.500" }}
                      />
                      <FormControl
                        position="absolute"
                        top="50%"
                        right="10px"
                        transform="translateY(-50%)"
                        width="auto"
                      >
                        <Checkbox
                          name="is_full"
                          isChecked={status.is_full === 1}
                          onChange={(e) => handleCheckboxChange(status.id, e)} // Open confirmation dialog
                          colorScheme="green"
                        />
                      </FormControl>
                    </FormControl>
                  </Box>
                </Box>
              ))}
          </Box>

          
        </Grid>
      </Box>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              تأیید تغییر
            </AlertDialogHeader>

            <AlertDialogBody>
              {isChecked === true
                ? "آیا مطمئن هستید که می‌خواهید ظرفیت را پر کنید؟"
                : "آیا مطمئن هستید که می‌خواهید این ظرفیت را خالی کنید؟"}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                لغو
              </Button>
              <Button colorScheme="red" onClick={confirmChange} ml={3}>
                تأیید
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default AccountStatus;
